export const sanitizePhoneNumber = (_phoneNumber: string): string => {
	const numStartWithPlus = _phoneNumber.slice(0, 1) === "+";
	return numStartWithPlus ? _phoneNumber.slice(1, _phoneNumber.length) : _phoneNumber;
};
